import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Typography,
  Switch,
  Button,
  Space,
  Divider,
  Dropdown,
  Menu,
  message,
  notification,
  Skeleton,
} from "antd";
import { useHistory } from "react-router-dom";
import { IoCloudDoneOutline } from "react-icons/io5";
import CustomiseFieldModal from "./CustomiseFieldModal";
import Can from "../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import ShareCatalogue from "assets/images/share_catalogue.svg";
import SendApproval from "assets/images/send_approval.svg";
import SendForApprovalModal from "./SendForApprovalModal";
import API_KEY from "api/index";
import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";
import GenarateCatalogoueModal from "./GenarateCatalogoueModal";
import { randomString } from "../../../../utils/randomString";

const { Title, Text } = Typography;
export default function PageTitle({
  collectionId,
  tableData,
  setTableData,
  showCost,
  setShowCost,
  saving,
  setSaving,
  loadingProductCost,
  setLoadingProductCost,
  productCount,
  setProductCount,
}) {
  const [showModal, setShowModal] = useState(false);
  // const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCloudIcon, setShowCloudIcon] = useState(true);
  const [sendForApprovalModalVisible, setSendForApprovalModalVisible] =
    useState(false);
  const [genarateCatalogoueModalVisible, setGenarateCatalogoueModalVisible] =
    useState(false);

  const history = useHistory();
  const onChange = (isChecked) => {
    // console.log(`switch to ${isChecked}`);
    setLoadingProductCost(true);
    setShowCost(isChecked);
  };

  useEffect(() => {
    if (saving) {
      setShowCloudIcon(true);
    }
  }, [saving]);

  useEffect(() => {
    // console.log(location,'location');
    const newItem = localStorage.getItem("new");

    if (newItem === "true") {
      setShowModal(true);
    }
  }, []);
  const handleAddMoreProducts = () => {
    history.push({
      pathname: `/select-products/${collectionId}`,
      state: {
        type: "edit",
      },
    });
  };
  const handleCustomiseField = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const handleDone = (data) => {
    setShowModal(false);
    setTableData(data);
    const visibleAttrs = data.columns
      .filter(
        (col) => col.visible && col.is_internal === false && col.attribute_id
      )
      ?.map((col) => col.attribute_id)
      .join(",");
    API_KEY.URL.patch(`${API_KEY.path.collections}/${collectionId}`, {
      visible_attributes: visibleAttrs,
    });

    localStorage.setItem("new", false);
  };

  const showApprovalModal = () => {
    setSendForApprovalModalVisible(true);
  };

  const handleOkApprovalModal = () => {
    setSendForApprovalModalVisible(false);
  };

  const handleCancelApprovalModal = () => {
    setSendForApprovalModalVisible(false);
  };
  // const indexCollection = () => {
  //   const userData = localStorage.getItem("user");
  //   const user = userData && JSON.parse(userData);
  //   setLoading(true);
  //   API_KEY.URL.get(
  //     `${process.env.REACT_APP_API_SERVICE}indexingService/collection_products`,
  //     {
  //       params: {
  //         collection_id: collectionId,
  //         token: user?.access_token,
  //       },
  //     }
  //   )
  //     .then((res) => {
  //       console.log("res", res);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // };

  const validator = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    setLoading(true);

    axios
      .get(
        `${process.env.REACT_APP_API_SERVICE}validator/table/collection_products?collection_id=${collectionId}&token=${user?.access_token}`
      )
      .then((res) => {
        const data = res.data;
        setLoading(false);

        if (Object.keys(data).length > 0) {
          const keys = Object.keys(data);

          notification.error({
            message: (
              <h4 style={{ color: "white" }}>Currency or Unit not selected</h4>
            ),
            description: `You have not selected currency or unit for ${keys.join(
              ","
            )}.`,
            closeIcon: (
              <CloseOutlined style={{ color: "white", fontSize: 20 }} />
            ),
            style: {
              color: "white",
              background: "rgb(0,0,0,0.9)",
              borderRadius: 8,
            },
          });
          setLoading(false);
          setGenarateCatalogoueModalVisible(false);
        } else {
          setLoading(false);
          setGenarateCatalogoueModalVisible(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  const showGenarateCatalogoueModal = () => {
    // indexCollection();
    validator();
  };

  const handleOkGenarateCatalogoueModal = () => {
    setGenarateCatalogoueModalVisible(false);
  };

  const handleCancelGenarateCatalogoueModal = () => {
    setGenarateCatalogoueModalVisible(false);
  };

  const menu = (
    <Menu style={{ width: 400 }}>
      <Menu.Item
        key="0"
        onClick={() => {
          showApprovalModal();
        }}
        style={{ padding: "20px" }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Row>
              <Title level={5}>Send for Approval</Title>
            </Row>
            <Row>
              <Text type="secondary">Get this catalogue approved by admin</Text>
            </Row>
          </Col>
          <Col>
            <img
              src={SendApproval}
              alt="Approve"
              height={"60px"}
              width={"60px"}
            />
          </Col>
        </Row>
      </Menu.Item>
      <Can
        I={PERMISSIONS.download_ppt_excel.slug}
        a={PERMISSIONS.download_ppt_excel.permissionType}
      >
        <Menu.Divider />
        <Menu.Item
          key="1"
          onClick={() => {
            showGenarateCatalogoueModal();
          }}
          style={{ padding: "20px" }}
        >
          <Row justify="space-between" align="middle">
            <Col>
              <Row>
                <Title level={5}>Generate Catalogue</Title>
              </Row>
              <Row>
                <Text type="secondary">Create catalogue for a buyer</Text>
              </Row>
            </Col>
            <Col>
              <img
                src={ShareCatalogue}
                alt="catlougue"
                height={"60px"}
                width={"60px"}
              />
            </Col>
          </Row>
        </Menu.Item>
      </Can>
    </Menu>
  );

  const saveAsDraft = () => {
    const payload = {
      status: "draft",
    };

    setSaving(true);
    // save collection status
    API_KEY.URL.patch(`${API_KEY.path.collections}/${collectionId}`, payload)
      .then((res) => {
        setSaving(false);
        message.success("Collection saved as draft");
      })
      .catch((err) => {
        setSaving(false);
        console.log(err);
      });
  };
  const handleContinue = (values) => {
    values.collection_link =
      tableData?.collection_info.collection_link || randomString(7);
    values.status = "published";

    setSaving(true);
    API_KEY.URL.patch(
      `${API_KEY.path.collections}/${tableData?.collection_info?.id}`,
      values
    )
      .then((response) => {
        if (response.status === 200) {
          localStorage.removeItem("selectedProducts");
          localStorage.removeItem("new");
          history.push(
            `/collection-link/${response.data?.data?.collection_link}`
          );
        }
        API_KEY.URL.get(
          `${API_KEY.path.catalogue_created}/${tableData?.id}`
        ).then((res) => console.log("catalogue shared"));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePreview = (values, callback) => {
    API_KEY.URL.patch(
      `${API_KEY.path.collections}/${tableData?.id}`,
      values
    ).then((response) => {
      if (response.status === 200) {
        callback();
      }
    });
  };

  const uniqueAttrs =
    tableData?.columns
      .map((column) => {
        return (column.visible && column.attribute_id) ||
          (column.visible && column.name.toLowerCase() === "sub category")
          ? column.name
          : null;
      })
      .filter(Boolean) || [];
  // uniqueAttrs.push("Sub Category");

  return Object.keys(tableData || {}).length &&
    tableData?.collection_info?.collection_name ? (
    <>
      <CustomiseFieldModal
        showModal={showModal}
        closeModal={closeModal}
        handleDone={handleDone}
        tableData={tableData}
      />
      <SendForApprovalModal
        sendForApprovalModalVisible={sendForApprovalModalVisible}
        collectionDetails={tableData?.collection_info}
        handleOkApprovalModal={handleOkApprovalModal}
        handleCancelApprovalModal={handleCancelApprovalModal}
        saveAsDraft={saveAsDraft}
      />
      <GenarateCatalogoueModal
        collectionDetails={tableData?.collection_info}
        showGenarateCatalogoueModal={showGenarateCatalogoueModal}
        handleOkGenarateCatalogoueModal={handleOkGenarateCatalogoueModal}
        handleCancelGenarateCatalogoueModal={
          handleCancelGenarateCatalogoueModal
        }
        genarateCatalogoueModalVisible={genarateCatalogoueModalVisible}
        saveAsDraft={saveAsDraft}
        handleContinue={handleContinue}
        handlePreview={handlePreview}
        uniqueAttrs={uniqueAttrs}
      />

      <Row
        style={{ marginTop: "1.5em", marginBottom: "20px" }}
        justify="space-between"
      >
        <Col>
          <Row>
            <Col>
              <Title level={4} style={{ color: "#040E0C", margin: 0 }}>
                {tableData?.collection_info?.collection_name}
              </Title>
            </Col>

            <Col>
              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  marginLeft: 8,
                  position: "absolute",
                  bottom: -1,
                }}
              >
                {" "}
                {saving ? (
                  "Saving..."
                ) : showCloudIcon ? (
                  <IoCloudDoneOutline size={20} />
                ) : (
                  "Saved"
                )}
              </Text>
            </Col>
          </Row>
          <Text type="secondary">
            {" "}
            {productCount
              ? productCount
              : tableData?.collection_info?.product_count}{" "}
            products
          </Text>
        </Col>
        <Col span={14}>
          <Row justify="space-around">
            <Space style={{ width: "25%" }}>
              <Text
                onClick={() => {
                  setLoadingProductCost(true);
                  setShowCost((state) => !state);
                }}
                style={{ cursor: "pointer" }}
              >
                Show product cost
              </Text>{" "}
              <Switch onChange={onChange} checked={showCost} />
            </Space>
            <Button
              onClick={() => handleAddMoreProducts()}
              size="large"
              style={{ width: "23%" }}
            >
              Add products
            </Button>
            <Button
              size="large"
              style={{
                width: "23%",
                background: "#F0F8F6",
                border: "1px solid #0B7764",
                color: "#0B7764",
              }}
              onClick={() => handleCustomiseField()}
            >
              Customize table
            </Button>

            <Dropdown
              overlay={menu}
              disabled={tableData?.data_source ? false : true}
            >
              <Button
                size="large"
                loading={loading}
                disabled={tableData?.data_source ? false : true}
                style={{
                  width: "23%",
                  background: tableData?.data_source ? "#1D2624" : "gray",
                  border: tableData?.data_source ? "1px solid #1D2624" : "none",
                  color: "white",
                }}
              >
                Continue
              </Button>
            </Dropdown>
          </Row>
        </Col>
      </Row>
      {/* <Divider /> */}
    </>
  ) : (
    <Skeleton active />
  );
}
